import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["use", "size"];
import { View } from 'foundations-components/components/View';
import styled from 'styled-components';
import { CIRCLE_BASE_SIZE } from '../constants/baseValues';
import { getSize } from '../operators/getSize';
import { SkeletonGradient } from './SkeletonGradient';
import { jsx as _jsx } from "react/jsx-runtime";
const Circle = styled.div.withConfig({
  displayName: "SkeletonCircle__Circle",
  componentId: "lqdc8j-0"
})(["position:relative;overflow:hidden;border-radius:50%;inline-size:100%;block-size:100%;"]);
Circle.displayName = 'Circle';
const SkeletonCircle = _ref => {
  let {
      use = 'default',
      size = CIRCLE_BASE_SIZE
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(View, Object.assign({
    "data-loading": "true"
  }, props, {
    inlineSize: getSize(size),
    blockSize: getSize(size),
    minInlineSize: getSize(size),
    minBlockSize: getSize(size),
    children: /*#__PURE__*/_jsx(Circle, {
      children: /*#__PURE__*/_jsx(SkeletonGradient, {
        use: use
      })
    })
  }));
};
SkeletonCircle.displayName = 'SkeletonCircle';
export default SkeletonCircle;